// These are hardcoded values for machete api.
enum GridStyles {
  COLONIAL = 'colonial',
  DIAMOND = 'diamond',
  FARMHOUSE = 'farmhouse',
  NONE = 'none',
  PRAIRIE = 'prairie',
  VALANCE = 'valance',
}

enum FrameStyles {
  CASEMENT = 'casement',
  DOUBLE_HUNG = 'doublehung',
  SLIDER = 'slider',
}

export { GridStyles, FrameStyles };
